import axios from '../utils/auth';

const saveAd = (inputs) => {
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const formData = new FormData();
    for (var key in inputs) {
        formData.append(key, inputs[key]);
    }
    formData.append('currentLang', currentLang);

    return axios().post("advertisement/create", formData);
}

const adList = (inputs) => {
    return axios().post("advertisement/list", inputs);
}
const adDetails = (id) => {
    return axios().get("advertisement/details/" + id);
}
const adPublic = (params) => {
    return axios().get("advertisement/view/" + params.id + "?activeLang=" + params.currentLang);
}
const adDelete = (id) => {
    return axios().get("advertisement/delete/" + id);
}
const allAd = (inputs) => {
    return axios().post("advertisement/all", inputs);
}

const adService = {
    saveAd,
    adList,
    adDetails,
    adPublic,
    adDelete,
    allAd
};

export default adService;
